<template>
  <transition name="fade">
    <div
      v-if="visible"
      :class="classes"
    >
      {{ message }}
    </div>
  </transition>
</template>

<script>
import {reactive} from "vue";

export default {
  props: {
    message: {
      type: String,
      required: true
    },
    duration: {
      type: Number,
      default: 2000 // Duration to show the popup in milliseconds
    },
    type: {
      type: String,
      default: "message",
      validator: (value) => [
        'message',
        'warning',
        'error',
        'success'
      ].includes(value)
    }
  },
  setup(props) {

    props = reactive(props);
    return {
      classes: {
        "popup": true,
        [`popup-type--${props.type || 'message'}`]: true
      },

    };
  },
  data() {
    return {
      visible: false
    };
  },
  methods: {
    show() {
      this.visible = true;
      setTimeout(() => {
        this.visible = false;
      }, this.duration);
    }
  }
};
</script>

<style>
.popup {
  position: fixed;
  top: 20px;
  left: 50vw;
  background-color: #333;
  color: #fff;
  padding: 10px;
  border-radius: 5px;
  transition: opacity 0.5s;
  opacity: 0.9;
  z-index: 1000;

  &.popup-type--warning {
    @apply bg-amber-500 text-white;
  }
  &.popup-type--success {
    @apply bg-green-600 text-white;
  }
  &.popup-type--error {
    @apply bg-red-600 text-white;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}
</style>
